var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFlipCameraIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 6.66667H22.4403L20.0003 4H12.0003L9.56033 6.66667H5.33366C3.86699 6.66667 2.66699 7.86667 2.66699 9.33333V25.3333C2.66699 26.8 3.86699 28 5.33366 28H26.667C28.1337 28 29.3337 26.8 29.3337 25.3333V9.33333C29.3337 7.86667 28.1337 6.66667 26.667 6.66667ZM16.0003 24C12.3203 24 9.33366 21.0133 9.33366 17.3333H6.66699L10.0003 14L13.3337 17.3333H10.667C10.667 20.28 13.0537 22.6667 16.0003 22.6667C16.7737 22.6667 17.507 22.4933 18.1603 22.2L19.147 23.1867C18.2003 23.68 17.147 24 16.0003 24ZM22.0003 20.6667L18.667 17.3333H21.3337C21.3337 14.3867 18.947 12 16.0003 12C15.227 12 14.4937 12.1733 13.8403 12.4667L12.8537 11.4933C13.8003 10.9867 14.8537 10.6667 16.0003 10.6667C19.6803 10.6667 22.667 13.6533 22.667 17.3333H25.3337L22.0003 20.6667Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlipCameraIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flip-camera-icon.d3202f3c.svg";
export { ForwardRef as ReactComponent };